import { gql, useMutation } from '@apollo/client';
import useQueryErrorHandler from '../../../../core/hooks/useQueryErrorHandler';
import { QueryStatusData } from 'core/hooks/useQueryHelper';
import { useCallback } from 'react';
import { ChangeExtraServiceOrderResponseType, ExtraServiceOrderChangeInput } from '../../../types/extraServiceOrder';

const changeExtraServiceDocument = gql`
    mutation changeExtraServiceOrder($serviceData: ExtraServiceOrderChangeInput!) {
        changeExtraServiceOrder(serviceData: $serviceData) {
            isSuccessful
            message
        }
    }
`;

const useMutationChangeExtraServiceOrder = (): MutationChangeExtraServiceOrderReturnType => {
    const { errorHandler } = useQueryErrorHandler();
    const [changeRequest, changeResponse] = useMutation(changeExtraServiceDocument);

    const changeExtraServiceOrder = useCallback(
        (serviceData: ExtraServiceOrderChangeInput) =>
            changeRequest({
                variables: {
                    serviceData,
                },
            }).catch((e) => {
                errorHandler(e);
                throw e;
            }),
        [changeRequest, errorHandler],
    );

    return {
        response: changeResponse.data as ChangeExtraServiceOrderResponseType | undefined,
        error: changeResponse.error,
        loading: changeResponse.loading,
        changeExtraServiceOrder,
    };
};

export default useMutationChangeExtraServiceOrder;

type MutationChangeExtraServiceOrderReturnType = QueryStatusData & {
    response?: ChangeExtraServiceOrderResponseType;
    changeExtraServiceOrder(serviceData: ExtraServiceOrderChangeInput): Promise<unknown>;
};
